import * as THREE from "three";
const loader = new THREE.TextureLoader();
export default loader;
